import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// 创建Supabase客户端实例，增强配置
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'files-system-auth',
    storage: localStorage
  },
  // 注意：不要在 global.headers 中设置 Content-Type
  // 否则会覆盖 Storage 上传时的 contentType 设置，导致图片无法正确显示
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});